import {Context, LocalActor} from '@acng/frontend-relativity';

/**
 * @type {Local<NovaList<any>>}
 */
export const ctxList = Context();

/**
 * Create a type annotated private list actor function.
 */
export const Actor = () => {
  const broadcast_ = LocalActor(ctxList);

  /**
   * @template T
   * @param {Element} element
   * @param {NovaList<T>["more"]} more
   * @param {NovaList<T>["ItemLink"]} ItemLink
   * @param {NovaList<T>["initial"]} [initial]
   */
  return (element, more, ItemLink, initial = []) => {
    broadcast_(element, {initial, more, ItemLink});
  };
};
